module.exports = __webpack_public_path__ + "img/michalia.b0f67299.jpg";